import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const GET_EA_TARGET_VALUE_SOURCES = "GET_EA_TARGET_VALUE_SOURCES";

export const service = async (data) => {
  const options: object = {
    url: `/api/ExternalAudit/GetEaTargetTypeValues/`,
    method: "POST",
    body: JSON.stringify(data),
    ...getDefaultOptions(),
  };

  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_EA_TARGET_VALUE_SOURCES, service, mock);
